/**
 * Admin 페이지 경로 prefix.
 * URL 추측을 어렵게 하기 위해 `/admin` 앞에 추가되는 obscure 디렉토리.
 *
 * 변경 시 다음을 모두 수정해야 함:
 * 1. 이 상수
 * 2. `src/app/<prefix>/admin` 폴더명 (실제 디렉토리 이동 필요)
 *
 * 주의: 이 값은 클라이언트 번들에도 포함될 수 있습니다.
 * 실제 접근 보안은 `src/proxy.ts`의 ADMIN_EMAIL 검증이 담당합니다 (Next 16에서 `middleware.ts`가 리네임됨).
 */
export const ADMIN_PATH_PREFIX = "jh-7zk3m";

/**
 * Admin 기본 URL 베이스. (`/<prefix>/admin`)
 */
export const ADMIN_PATH_BASE = `/${ADMIN_PATH_PREFIX}/admin` as const;

/**
 * Admin MDX 콘텐츠 카테고리 (slash 없이 시작).
 * `getPost(slug, ADMIN_CONTENT_CATEGORY)` / `getPostSlugs(...)` 같은 helper에 사용.
 * 실제 폴더: `src/app/<prefix>/admin/contents`
 */
export const ADMIN_CONTENT_CATEGORY = `${ADMIN_PATH_PREFIX}/admin` as const;

/**
 * 주어진 admin sub path를 prefix가 적용된 풀 경로로 변환.
 *
 * @example
 * adminPath("/finance") // "/jh-7zk3m/admin/finance"
 * adminPath("finance")  // "/jh-7zk3m/admin/finance"
 */
export function adminPath(subPath: string = ""): string {
  if (!subPath) return ADMIN_PATH_BASE;
  const normalized = subPath.startsWith("/") ? subPath : `/${subPath}`;
  return `${ADMIN_PATH_BASE}${normalized}`;
}

/**
 * 환경변수 ADMIN_EMAIL을 파싱해 관리자 이메일 목록을 반환.
 * 단일 이메일, 쉼표 구분, `[email1, email2]` 배열 형태 모두 지원.
 */
export function parseAdminEmails(adminEmailEnv: string | undefined): string[] {
  if (!adminEmailEnv) return [];

  if (adminEmailEnv.startsWith("[") && adminEmailEnv.endsWith("]")) {
    const emailList = adminEmailEnv.slice(1, -1);
    return emailList.split(",").map((email) => email.trim()).filter(Boolean);
  }

  return adminEmailEnv.split(",").map((email) => email.trim()).filter(Boolean);
}

/**
 * 주어진 이메일이 관리자 이메일 목록에 포함되는지 검증.
 */
export function isAdminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  const adminEmails = parseAdminEmails(process.env.ADMIN_EMAIL);
  return adminEmails.includes(email);
}
